/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { updateAccountWithResult } from "@eisinc/App/Services/AccountService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    CallUpdateAccount,
    chain,
    ExecuteOnSuccessCallback,
    GetCurrentAccount,
    UpdateSession,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";

export const XngGetCurrentAccount: any = (props: any) => {
    const firstName = props.getState().accountNames.firstName;
    const lastName = props.getState().accountNames.lastName;

    let account = props.getState().pages.accountSettings.editingAccount;

    if (!account) {
        throw new Error("There was no current account when we are trying to save the current account");
    }

    account = { ...account, firstName, lastName };
    props.account = account;
};

export const XngCallUpdateAccount: any = async (props: any) => {
    const updatedAccountResult = await updateAccountWithResult(props.apiParameter);

    if ((updatedAccountResult as any)?.result) {
        props.apiResult = (updatedAccountResult as any)?.result;
        return;
    }
    props.parameter.errorMessage = (updatedAccountResult as any)?.errorMessage;
};

export const XngUpdateSession: any = (props: any) => {
    if (props.apiResult) {
        props.dispatch({
            type: "Context/CompleteLoadSession",
            session: {
                ...props.getState().context.session,
                email: props.apiResult.email,
                userName: props.apiResult.userName,
            },
        });
    }
};

export const XngExecuteOnSuccessCallback: any = (props: any) => {
    if (props.apiResult) {
        props.parameter.onSuccess?.();
    } else {
        // In case we have error
        props.parameter?.onSuccess(props.parameter?.errorMessage);
    }
};

replaceInChain(chain, GetCurrentAccount, XngGetCurrentAccount);
replaceInChain(chain, CallUpdateAccount, XngCallUpdateAccount);
replaceInChain(chain, UpdateSession, XngUpdateSession);
replaceInChain(chain, ExecuteOnSuccessCallback, XngExecuteOnSuccessCallback);
